<section *ngIf="selectedDataSourceType">
  <h3 *ngIf="selectedDataSourceType?.name"> {{selectedDataSourceType?.name}}</h3>
  <p *ngIf="selectedDataSourceType?.description">
    {{selectedDataSourceType?.description}}
  </p>
</section>
<div [ngClass]="{'section-active': !dataSourceId}">
  <rappider-crud-view-edit-form *ngIf="predefinedData"
                                class="datasource-add-with-file-form"
                                [config]="fileDatasourceCreateFormConfig"
                                [data]="predefinedData"
                                [submitButtonLoading]="submitButtonLoading"
                                (formValueChange)="onFileCreateFormValueChange($event)"
                                (nextClick)="onNextClick($event)"
                                (doneClick)="onJoyrideDoneButtonClick()"
                                (renderCompleted)="onRenderCompleted($event)"
                                (formSubmit)="onFileCreateFormSubmit($event)">
  </rappider-crud-view-edit-form>
</div>
